module.exports = __webpack_public_path__ + "files/ffe30c750f2fd94fd91303c719196c5c.png";